import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CertificatesModule } from '../certificates/certificates.module';
import { B2bGroupClassesBannerModule } from '../components/b2b-group-classes-banner/b2b-group-classes-banner.component';
import { ChatBotFabModule } from '../components/chat-bot-fab/chat-bot-fab.component';
import { ChatBotModalModule } from '../components/chat-bot-modal/chat-bot-modal.component';
import { GenericTileBodyModule } from '../components/generic-tile-body/generic-tile-body.component';
import { LCOnboardingIframeModule } from '../components/lc-onboarding-iframe/lc-onboarding-iframe.component';
import { OverlayModule } from '../overlay/overlay.module';
import { ArrowLinkModule } from '../shared/arrow-link/arrow-link.component';
import { BalloonPopupModule } from '../shared/balloon-popup/balloon-popup.component';
import { ChatBotNotificationService } from '../shared/chat-bot-notification.service';
import { EndOfLevelCongratulationModule } from '../shared/end-of-level-congratulation/end-of-level-congratulation.module';
import { SharedModule } from '../shared/shared.module';
import { ChatBotBannerComponent } from './chat-bot-banner/chat-bot-banner.component';
import { ChatBotSectionComponent } from './chat-bot-section/chat-bot-section.component';
import { GenericTileModule } from './generic-tile/generic-tile.module';
import { IdiomCarouselComponent } from './idiom-carousel/idiom-carousel.component';
import { IdiomTileComponent } from './idiom-tile/idiom-tile.component';
import { ImmersionCarouselService } from './immersion-carousel/immersion-carousel.service';
import { IndustryContentCarouselModule } from './industry-content-carousel/industry-content-carousel.module';
import { IndustryContentSectionModule } from './industry-content-section/industry-content-section.module';
import { LeaderboardActiveComponent } from './leaderboard-active/leaderboard-active.component';
import { LeaderboardErrorComponent } from './leaderboard-error/leaderboard-error.component';
import { LeaderboardInactiveComponent } from './leaderboard-inactive/leaderboard-inactive.component';
import { LeaderboardInitialComponent } from './leaderboard-initial/leaderboard-initial.component';
import { LiveClassEventService } from './live-class-event.service';
import { LiveClassSectionModule } from './live-class-section/live-class-section.module';
import { LiveClassService } from './live-class.service';
import { MiniLessonSectionModule } from './mini-lesson-section/mini-lesson-section.module';
import { NewsCarouselComponent } from './news-carousel/news-carousel.component';
import { NewsTileComponent } from './news-tile/news-tile.component';
import { OnboardingBannerComponent } from './onboarding-banner/onboarding-banner.component';
import { PracticeSectionComponent } from './practice-section/practice-section.component';
import { SpeechaceCarouselComponent } from './speechace-carousel/speechace-carousel.component';
import { SpeechaceTileComponent } from './speechace-tile/speechace-tile.component';
import { StudyBundleProgressV2Component } from './study-bundle-progress-v2/study-bundle-progress-v2.component';
import { StudyBundleComponent } from './study-bundle/study-bundle.component';
import { VideosCarouselComponent } from './videos-carousel/videos-carousel.component';
import { VideosTileComponent } from './videos-tile/videos-tile.component';
import { BannerRouletteComponent } from './banner-roulette/banner-roulette.component';
import { YearInReviewBannerComponent } from '../components/year-in-review-banner/year-in-review-banner.component';
import { ProfileAvatarModule } from '../components/profile-avatar/profile-avatar.component';

@NgModule({
  declarations: [
    IdiomCarouselComponent,
    IdiomTileComponent,
    NewsCarouselComponent,
    NewsTileComponent,
    OnboardingBannerComponent,
    PracticeSectionComponent,
    SpeechaceCarouselComponent,
    SpeechaceTileComponent,
    StudyBundleComponent,
    VideosCarouselComponent,
    VideosTileComponent,
    StudyBundleProgressV2Component,
    LeaderboardInitialComponent,
    LeaderboardActiveComponent,
    LeaderboardInactiveComponent,
    LeaderboardErrorComponent,
    ChatBotSectionComponent,
    ChatBotBannerComponent,
    BannerRouletteComponent,
    YearInReviewBannerComponent
  ],
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    CertificatesModule,
    SharedModule,
    OverlayModule,
    IndustryContentCarouselModule,
    IndustryContentSectionModule,
    MiniLessonSectionModule,
    GenericTileModule,
    GenericTileBodyModule,
    LiveClassSectionModule,
    ArrowLinkModule,
    LCOnboardingIframeModule,
    B2bGroupClassesBannerModule,
    EndOfLevelCongratulationModule,
    ChatBotModalModule,
    ChatBotFabModule,
    BalloonPopupModule,
    ProfileAvatarModule
  ],
  providers: [LiveClassService, LiveClassEventService, ImmersionCarouselService, ChatBotNotificationService],
})
export class HomeModule {}



// WEBPACK FOOTER //
// ./ts/app/home/home.module.ts